import moment from "moment/moment";
import React from "react";

const FlightDetail = ({ flightData }) => {
  const { flight_segments, flight_booking_details } = flightData || {};

  const Fare = flightData?.params?.Fare || {};

  const getPassengerType = (type) => {
    switch (type) {
      case 1:
        return "Adult";
        break;
      case 2:
        return "Child";
        break;
      case 3:
        return "Infant";
        break;
    }
  };

  return (
    <>
      <div>
        <h4>flight booking details</h4>
        <h3 className="b-semi-16">Ticket Details</h3>
        <div className="review-booking-wrapper ticket-details-two-lists">
          {flight_segments.map((ele) => {
            const {
              AirlineDetails,
              Airline,
              FlightNumber,
              CabinClass,
              DepartureTime,
              Duration,
              ArrivalTime,
              IncludedBaggage,
              CabinBaggage,
            } = ele || {};

            return (
              <>
                <div className="row align-items-center">
                  <div className="col-lg-12">
                    <div className="ticket-details-main-title">
                      <h4 className="bold20">
                        {ele.Origin.CityName} - {ele.Destination.CityName}
                      </h4>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12">
                    <div className="flight-listing-inner">
                      <img
                        src={`assets/AirlineLogo/${ele?.AirlineDetails.AirlineCode}.gif`}
                        style={{ height: "35px", width: "35px" }}
                        // alt={}
                      />
                      <h4 className="bold20">{AirlineDetails.AirlineName}</h4>
                      <p className="medium16">{CabinClass}</p>
                      <p className="medium16">
                        {Airline} - {FlightNumber}
                      </p>
                      <p className="medium16">
                        (Aircraft: {AirlineDetails.Craft})
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12">
                    <div className="flight-listing-inner">
                      <p className="medium16">
                        {moment(DepartureTime).format("ddd MMM DD YYYY")}
                      </p>
                      <h4 className="bold20">
                        {ele.Origin.CityCode}{" "}
                        <span className="medium20">
                          {moment(DepartureTime).format("HH:mm")}
                        </span>
                      </h4>
                      <p className="medium12">
                        {ele.Origin?.AirportName},{ele.Origin?.CityName},{" "}
                        {ele.Origin?.CountryName} (Terminal
                        {" " + ele.Origin?.Terminal})
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12">
                    <div className="flight-listing-inner">
                      <h5 className="bold20">
                        {Duration.split(":")[0]}h {Duration.split(":")[1]}m
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12">
                    <div className="flight-listing-inner">
                      <p className="medium16">
                        {moment(ArrivalTime).format("ddd MMM DD YYYY")}
                      </p>
                      <h4 className="bold20">
                        {ele.Destination.CityCode}{" "}
                        <span className="medium20">
                          {moment(ArrivalTime).format("HH:mm")}
                        </span>
                      </h4>
                      <p className="medium12">
                        {ele.Destination?.AirportName},
                        {ele.Destination?.CityName},{" "}
                        {ele.Destination?.CountryName} (Terminal
                        {" " + ele.Destination?.Terminal})
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="flight-listing-main-details">
                      <div>
                        <p className="medium14">
                          {IncludedBaggage} Check-In{" "}
                          {CabinBaggage !== "Included" &&
                            CabinBaggage != undefined &&
                            CabinBaggage + ", Cabin"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>

        <div>
          {flightData.params.Itinerary.Passenger.map((ele, ind) => {
            return (
              <div className="flight-booking-guest-detail">
                <h5 className="semi16">
                  Guest {ind + 1} {getPassengerType(ele.Type)}
                </h5>
                <div className="flight-booking-guest-detail-wrapper">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="flight-booking-guest-detail-inner d-flex align-items-start">
                        <div className="guests-hotel-icon">
                          <img src="/assets/images/guests.svg" alt="err" />
                        </div>
                        <div>
                          <p className="b-semi-14">
                            {ele.Title}. {ele.FirstName} {ele.LastName}
                          </p>
                          <p className="b-medium-12">
                            <span className="b-semi-12">DOB:-</span>{" "}
                            {moment(ele.DateOfBirth).format("MMMM Do YYYY")}{" "}
                          </p>
                          <p className="b-medium-12">
                            <span className="b-semi-12">Gender:-</span>{" "}
                            {ele.Gender === 1
                              ? "Male"
                              : ele.Gender === 2
                              ? "Female"
                              : "Other"}
                          </p>
                          {ele.IsLeadPax && (
                            <p className="b-medium-12">Lead Passenger</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="flight-booking-guest-detail-inner">
                        <div className="id-tyle-flight-detail">
                          <p className="b-semi-14">
                            {" "}
                            {ele.Title}. {ele.FirstName} {ele.LastName}
                          </p>
                          <p className="b-medium-14">
                            {ele.PassengerIdType !== undefined &&
                            ele.PassengerIdType !== null
                              ? ele.PassengerIdType
                              : "-"}
                          </p>
                        </div>
                        <div className="id-tyle-flight-detail">
                          <p className="b-semi-14">ID Number</p>
                          <p className="b-medium-14">
                            {ele.PassengerIdNo !== undefined &&
                            ele.PassengerIdNo !== null
                              ? ele.PassengerIdNo
                              : "-"}
                          </p>
                        </div>
                        <div className="id-tyle-flight-detail">
                          <p className="b-semi-14">ID Issue Date</p>
                          <p className="b-medium-14">
                            {ele.PassengerIdIssueDate !== undefined &&
                            ele.PassengerIdIssueDate !== null
                              ? ele.PassengerIdIssueDate
                              : "-"}
                          </p>
                        </div>
                        <div className="id-tyle-flight-detail">
                          <p className="b-semi-14">ID Expire Date</p>
                          <p className="b-medium-14">
                            {ele.PassengerIdExpiry !== undefined &&
                            ele.PassengerIdExpiry !== null
                              ? ele.PassengerIdExpiry
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

          <div className="row">
            <div className="col-lg-6">
              <div className="flight-booking-guest-detail">
                <div className="flight-booking-guest-detail-wrapper flight-booking-email-detail">
                  <div>
                    <p className="b-semi-14">Email:-</p>
                    <p className="b-medium-14">
                      {flight_booking_details[0]?.passenger_email}
                    </p>
                  </div>
                  <div>
                    <p className="b-semi-14">Mobile Number</p>
                    <p className="b-medium-14">
                      {flight_booking_details[0]?.passenger_countrycode}{" "}
                      {flight_booking_details[0]?.passenger_mobile}
                    </p>
                  </div>
                  <div>
                    <p className="b-semi-14">Nationality</p>
                    <p className="b-medium-14">
                      {flight_booking_details[0]?.Nationality?.CountryName}
                    </p>
                  </div>
                  <div>
                    <p className="b-semi-14">City</p>
                    <p className="b-medium-14">
                      {flight_booking_details[0]?.City?.CityName}
                    </p>
                  </div>
                  <div>
                    <p className="b-semi-14">Address</p>
                    <p className="b-medium-14">
                      {flight_segments[0]?.Origin.AirportName} (
                      {flight_segments[0]?.Origin.AirportCode}),{" "}
                      {flight_segments[0]?.Origin.CityName},{" "}
                      {flight_segments[0]?.Origin.CountryName}.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="flight-booking-guest-detail-wrapper price-summary-wrap mt-0">
                <ul>
                  <h5 className="b-b-20 mb-2">Price Summary</h5>
                  <li>
                    <p className="medium16">Travelers 1 Adult</p>
                  </li>
                </ul>
                <ul className="mt-4">
                  <li>
                    <p className="b-semi-14">Base Fare</p>

                    <p className="b-medium-14">
                      ${parseFloat(Fare.BaseFare).toFixed(2)}
                    </p>
                  </li>
                  <li>
                    <p className="b-semi-14">Fee & Surcharge </p>
                    <p className="b-medium-14">
                      ${parseFloat(Fare.Tax).toFixed(2)}
                    </p>
                  </li>
                  <li>
                    <p className="blue-b-16">Total Amount to be Paid</p>
                    <p className="blue-b-16">
                      ${parseFloat(Fare.TotalFare).toFixed(2)}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FlightDetail;
